import { MakeQueryString } from 'front-utility';
import { ApiRoute } from 'api-base-refrence';
import { HomePageApiRoute } from './home-page.api';
import { NestjsPageFilter } from 'nestjs-model-utility';
import { Home } from '../../../domain/entity/home.entity';

export class HomePageFilterApiRoute extends ApiRoute {
  static apiName = 'site_management__home';
  static parent = HomePageApiRoute;
  static urlPattern(
    filter?: NestjsPageFilter<keyof Home> & {
      ownerId: number;
      activeProjects?: boolean;
    },
  ) {
    return `?${MakeQueryString(filter)}`;
  }
}
